import { gql } from '@src/lib/gql'

/** L17: replace the booking-link waive code; the old code stops working at once. */
export const ROTATE_ADVISOR_SESSION_FEE_WAIVE_CODE = gql`
  mutation RotateAdvisorSessionFeeWaiveCode($input: RotateAdvisorSessionFeeWaiveCodeInput!) {
    rotateAdvisorSessionFeeWaiveCode(input: $input) {
      advisorProfile {
        id
        advisorProfileId
        sessionFeeWaiveCode
        bookingLinkSessionsCount
      }
    }
  }
`
